import React from 'react';

import Footers from './Footer/Footers';
import FootersUsage from './Footer/FootersUsage';

import Maps from './Map/Maps';
import MapsUsage from './Map/MapsUsage';

import Accordions from './Accordion/Accordions';
import AccordionsUsage from './Accordion/AccordionsUsage';

import Notifications from './Notification/Notifications';
import NotificationsUsage from './Notification/NotificationsUsage';

import Forms from './Form/Forms';
import FormsUsage from './Form/FormsUsage';

import Headers from './Header/Headers';
import HeadersUsage from './Header/HeadersUsage';

import VerticalSectionMarker from './VerticalSectionMarker/VerticalSectionMarker';
import VerticalSectionMarkerUsage from './VerticalSectionMarker/VerticalSectionMarkerUsage';

import Banners from './Banner/Banners';
import BannersUsage from './Banner/BannersUsage';

import Hotspots from './Hotspots/Hotspots';
import HotspotsUsage from './Hotspots/HotspotsUsage';

/* eslint-disable react/display-name */
const Components = {
  Footers: () => <Footers />,
  FootersUsage: () => <FootersUsage />,

  Maps: () => <Maps />,
  MapsUsage: () => <MapsUsage />,

  Accordions: () => <Accordions />,
  AccordionsUsage: () => <AccordionsUsage />,

  Notifications: () => <Notifications />,
  NotificationsUsage: () => <NotificationsUsage />,

  Forms: () => <Forms />,
  FormsUsage: () => <FormsUsage />,

  Headers: () => <Headers />,
  HeadersUsage: () => <HeadersUsage />,

  VerticalSectionMarker: () => <VerticalSectionMarker />,
  VerticalSectionMarkerUsage: () => <VerticalSectionMarkerUsage />,

  Banners: () => <Banners />,
  BannersUsage: () => <BannersUsage />,
  
  Hotspots: () => <Hotspots />,
  HotspotsUsage: () => <HotspotsUsage /> 
};

export default Components;



// WEBPACK FOOTER //
// ./src/containers/components/index.js